import script from "./NavMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./NavMenuItem.vue?vue&type=style&index=0&id=6b59b742&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b59b742"]])

export default __exports__